module.exports = __webpack_public_path__ + "static/media/IMG_8399_cropped3.2d23f11b.jpg";